import { SVGProps } from 'react';

const CalendarIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.33333 6.16667V1.5M16.6667 6.16667V1.5M6.16667 10.8333H17.8333M3.83333 22.5H20.1667C20.7855 22.5 21.379 22.2542 21.8166 21.8166C22.2542 21.379 22.5 20.7855 22.5 20.1667V6.16667C22.5 5.54783 22.2542 4.95434 21.8166 4.51675C21.379 4.07917 20.7855 3.83333 20.1667 3.83333H3.83333C3.21449 3.83333 2.621 4.07917 2.18342 4.51675C1.74583 4.95434 1.5 5.54783 1.5 6.16667V20.1667C1.5 20.7855 1.74583 21.379 2.18342 21.8166C2.621 22.2542 3.21449 22.5 3.83333 22.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
);

export default CalendarIcon;
